module.exports = __webpack_public_path__ + "img/paysafecash.a19a49f7.svg";